import { createStore } from "vuex";
import Keycloak from "keycloak-js";
import config from "@/../config";
import router from "@/router";
import RealmTracker from "@/_helpers/RealmTracker";
import LocalStorageCleaner from "@supervision/vue-components/_helpers/LocalStorageCleaner";

const keycloak = new Keycloak({
  url: config.value("VUE_APP_KEYCLOAK_URL"),
  realm: RealmTracker.getRealm(),
  clientId: config.value("VUE_APP_CLIENT_ID"),
});

const store = createStore({
  state: {
    keycloakInstance: null,
    token: null,
    app: null,
  },
  mutations: {
    setApp(state, app) {
      state.app = app;
    },
    setKeycloakInstance(state, keycloak) {
      state.keycloakInstance = keycloak;
    },
    setToken(state, token) {
      state.token = token;
    },
  },
  actions: {
    async initializeKeycloak({ commit, dispatch }, app) {
      try {
        commit("setApp", app);
        const authenticated = await keycloak.init({
          onLoad: "login-required",
          checkLoginIframe: false,
        });
        if (authenticated) {
          if (
            keycloak.tokenParsed.role.includes("AmrPortal-access") ||
            keycloak.hasRealmRole("AmrPortal-access")
          ) {
            if (app.config.globalProperties.$route.name !== "amrHome") {
              router.replace({ name: "amrHome" });
            }
          } else {
            router.replace({ name: "access_forbidden" });
          }

          commit("setKeycloakInstance", keycloak);
          commit("setToken", keycloak.token);
          app.config.globalProperties.$jwt.initToken(keycloak.token);
          app.config.globalProperties.$keycloak = keycloak;
          app.mount("#AmrPortal");
          LocalStorageCleaner.cleanStorage();
          dispatch("setupTokenRefresh", app);
        } else {
          keycloak.logout({
            redirectUri:
              window.location.origin +
              "/" +
              app.config.globalProperties.$realm +
              "/home",
          });
        }
      } catch (error) {
        console.error("Failed to initialize Keycloak", error);
      }
    },
    setupTokenRefresh({ dispatch }, app) {
      // don't worry this will not be fired while keycloak event is fired correctly but it will be if an inactive tab or window didn't listen to keycloak onTokenExpired event
      setInterval(() => {
        dispatch("refreshToken", app);
      }, 10000);
    },
    refreshToken({ state, commit }, app) {
      let keycloak = state.keycloakInstance;
      keycloak
        .updateToken(30)
        .then((refreshed) => {
          if (refreshed) {
            app.config.globalProperties.$jwt.initToken(keycloak.token);
            commit("setKeycloakInstance", keycloak);
            commit("setToken", keycloak.token);
          }
        })
        .catch((error) => {
          console.error("Failed to refresh token", error);
        });
    },
    hasRealmRole(_, role) {
      return keycloak.hasRealmRole(role);
    },
  },
});

keycloak.onTokenExpired = () => {
  store.dispatch("refreshToken", store.state.app);
};

export default store;
